import { render, staticRenderFns } from "./personpic.vue?vue&type=template&id=208b881e&scoped=true&"
import script from "./personpic.vue?vue&type=script&lang=js&"
export * from "./personpic.vue?vue&type=script&lang=js&"
import style0 from "./personpic.vue?vue&type=style&index=0&id=208b881e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208b881e",
  null
  
)

export default component.exports